import React from "react";
import { useWarehouseContext } from "./WarehouseProvider";
import { WeightCapture } from "./components/WeightCapture";
import controlWeightIcon from "./images/control-weight-icon.png";

const TITLE = "Assembled Weight";

export const AssembledWeightCapture = () => {
  const { assembledWeight, setAssembledWeight } = useWarehouseContext();

  return (
    <WeightCapture
      title={TITLE}
      instruction="Empty the Assembled Non-conform material into the control container and record weight. Do not weigh the Non-conform bucket itself."
      icon={controlWeightIcon}
      iconAlt="Assembled Weight"
      value={assembledWeight}
      onChange={setAssembledWeight}
    />
  );
};

AssembledWeightCapture.title = TITLE;
